
import { defineComponent } from "vue";
import { api } from "@/common/api";

export default defineComponent({
    name: "BilibiliBot",
    data() {
        return {
            isLogin: false,
            qrcodeImageContent: "",
        };
    },

    async mounted() {
        await this.checkLogin();
    },

    methods: {
        async checkLogin() {
            this.qrcodeImageContent = "";

            let tRes = await api.get("bilibili-bot/is-login");
            this.isLogin = tRes.data["isLogin"];
        },

        async login() {
            let tRes = await api.get("bilibili-bot/login");
            this.qrcodeImageContent = tRes.data["qrcodeImageContent"];
        },

        // async logout() {
        //     let tRes = await api.get("bilibili-bot/logout");
        //     this.isLogin = tRes.data;
        // },
    },
});
